<template>
    <span>
        <select
        class="form-select"
        :aria-label="label"
        v-model="selected"
        :disabled="disabled"
        :required="required"
        >
        <option value="" disabled selected hidden><slot name="selectedOption"></slot></option>
        <option v-for="(option, index) in options" :key="index" :value="option.value">
            {{ option.text }} {{ option.status ? '(' + option.status + ')' : '' }}
        </option>
        </select>
    </span>
</template>
<script>
export default {
    props:{
        options: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
        },
        modelValue: {
            type: [String, Number]
        },
        key: {
            type: String, 
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        selected: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            }
        }
    }
}
</script>

<style scoped>
.form-select:focus {
    border-color: var(--primary-color, #f27178);
    box-shadow: 0 0 0 0.25rem var(--secondary-color, rgba(242, 113, 120, 0.25));
}
</style>